function parseFetchConfigurationsResponse(response) {
  response.items.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  response.items = response.items.map(item => {
    const version = item?.values?.info?.version || item?.name;
    const selectorLabel = version ? `${version} (${item?.keystreamId})` : item?.keystreamId;
    return {
      ...item,
      selectorLabel
    };
  });
  const deviceConfigurations = response.items.filter(config => config.type === 'device-specific' || config.type === 'deviceSpecific');
  const stateConfigurations = response.items.filter(config => config.type === 'state-specific' || config.type === 'stateSpecific');
  return {
    deviceConfigurations,
    stateConfigurations
  };
}
export default parseFetchConfigurationsResponse;